
import { CoachingPlanExerciseApi } from "../openapi";
import openApiConfig from "./http_service";

const coachingPlanExerciseApi=new CoachingPlanExerciseApi(openApiConfig)


export default coachingPlanExerciseApi